module.exports = __webpack_public_path__ + "img/login_footer.43180d73.svg";